<template>
  <div class="switch-card-list">

    <div class="card-list" ref="cardListRef" :style="{'transform': `translateX(-${this.currentIndex * eachStepWidth}px)`}">
      <slot></slot>
    </div>
    <div class="pre-icon" @click="onPre" v-if="showPreIcon">
      <span class="icon"></span>
    </div>
    <div class="next-icon" @click="onNext" v-if="showNextIcon">
      <span class="icon"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 分为多少份，传2则分为2份，可以点击一次前进
    stepNumber: {
      type: Number, 
      default: 2,
    },
  },
  data() {
    return {
      currentIndex: 0,
      eachStepWidth: 0,
      showIcon: false,
    };
  },
  computed: {
    showPreIcon() {
      return this.showIcon && this.currentIndex !== 0; // 大于一行并且点过next
    },
    showNextIcon() {
      return this.showIcon && this.currentIndex < this.stepNumber - 1;// 大于一行并且大于1步
    },
  },
  created() {
    this.getEachStepWidth();
  },
  updated() {
    this.getEachStepWidth();
  },
  methods: {
    onPre() {
      if (!this.showPreIcon) return; 
      this.currentIndex -= 1;
    },
    onNext() {
      if (!this.showNextIcon) return; 
      this.currentIndex += 1;
    },
    getEachStepWidth() {
      this.$nextTick(() => {
        if (!this.$refs.cardListRef || !this.$slots.default) return;
        // 将当前长度分为最大分数
        const contentWidth = this.$refs.cardListRef.offsetWidth;
        const slotListWidth = this.$slots.default[0] && this.$slots.default[0].elm ? this.$slots.default[0].elm.offsetWidth : 0;
        if (slotListWidth > contentWidth) {
          this.showIcon = true;
        }
        this.eachStepWidth = slotListWidth / this.stepNumber;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.switch-card-list{
  position: relative;
  width: 100%;
  overflow: hidden;
  .card-list {
    transition: all .2s;
  }
  .pre-icon, .next-icon {
    position: absolute;
    right: 0;
    width: 26px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    height: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    cursor: pointer;
    &::before{
      content: "";
      width: 1px;
      height: 100%;
      background: linear-gradient( 180deg, #FFFFFF 0%, rgb(247, 240, 240) 50%, #FFFFFF 100%);
      border-radius: 2px;
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
    }
    &::after{
      content: "";
      width: 24px;
      height: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .icon {
      width: 16px;
      height: 16px;
    }
  }
  .pre-icon {
    left: 0;
    padding-right: 9px;
    &::before{
      right: 0;
    }
    &::after{
      background: linear-gradient( -270deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
      right: -24px;
    }
    .icon {
      background: url(../../../../../../../../../assets/imgs/insurance-new/insurance-info/pre-icon.png) center center no-repeat;
      background-size: 100% 100%;
    }
  }
  .next-icon {
    right: 0;
    padding-left: 9px;
    &::before{
      left: 0;
    }
    &::after{
      background: linear-gradient( 270deg, #fff 0%, rgba(255,255,255,0) 100%);
      left: -24px;
    }
    .icon {
      background: url(../../../../../../../../../assets/imgs/insurance-new/insurance-info/next-icon.png) center center no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/theInsured-list/components/switch-card-list.vue